export const setCookie = (
  cname: string,
  cvalue: string,
  exdays: number
): void => {
  const day = new Date()
  day.setTime(day.getTime() + exdays * 24 * 60 * 60 * 1000)
  const expires = 'expires=' + day.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

export const getCookie = (cname: string): string => {
  const name = cname + '='
  const decodedCookie = decodeURIComponent(document.cookie)
  const ca = decodedCookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

export const deleteCookie = (cname: string): void => {
  document.cookie = cname + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
}

export const storeSession = (
  key: string,
  data: Record<string, unknown>,
  expired: { value: number } | null = null
): boolean => {
  const now = new Date()

  if (expired) {
    now.setHours(now.getHours() + expired.value)
  } else {
    now.setHours(now.getHours() + 1)
  }

  const authStore = {
    ...data,
    expired: now.getTime(),
    login_at: new Date()
  }

  const encode = window.btoa(JSON.stringify(authStore))
  setCookie(key, encode, 1)

  return true
}

export const getSession = (key: string): Record<string, unknown> | null => {
  const data = getCookie(key)
  if (data) {
    return JSON.parse(window.atob(data)) as Record<string, unknown>
  }
  return null
}

export const removeSession = (key: string): boolean => {
  deleteCookie(key)
  return true
}
